import {
  ADD_COMPANY,
  ADD_COMPANY_FAILED,
} from "./actions";

const initialState = {
  companies: [],
  isLoading: false,
  error: null,
};

const companyReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_COMPANY:
      return {
        ...state,
        isLoading: true,
      };
    case ADD_COMPANY_FAILED:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default companyReducer;